<div class="specification-content">
    <div class="center container-fluid container-lg">
        <div class="heading">
            <div class="improved-page-label">Project Specification Review</div>
            <!-- <form name="PcbDateForm" class="custom-create-project-form" id="PcbDateForm" [formGroup]="PcbDateForm">
                <div class="left-heading pb-2">
                    <div class="d-flex gap-2 align-items-center justify-content-end">
                        <div class="f-14">Intended Start Date:</div>
                        <div class="date-picker">
                            <mat-form-field class="example-form-field">
                                <input matInput [matDatepicker]="picker" [min]="minDate" formControlName="vDate">
                                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="d-flex align-items-center justify-content-end gap-2 gap-md-3">
                        <div class="f-14">Choose Manufacturing Location:</div>
                        <mat-radio-group formControlName="location" aria-label="Select an option">
                            <mat-radio-button value="1" checked>India</mat-radio-button>
                            <mat-radio-button value="2">USA</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </form> -->
        </div>
 
        <div class="input-container m-quote-input-container ">
            <div class="pcb-container w-35" *ngIf="showPcbSpecifications">
                <div class="sub-header-name">PCB Specification Selection</div>
                <div class="custom-card card-one">
                    <form name="updatepcbForm" class="custom-create-project-form" id="updatepcbForm"
                        [formGroup]="updatepcbForm">
                        <div class="grey-bg position-relative">
                            <div class="input-group d-flex ">
                                <div class="position-relative col-7 p-0">
                                    <div class="d-flex">
                                <label for="dimensions" class="form-label">Dimensions<span
                                        class="text-danger">*</span></label>
                                <input type="text" class="form-control" id="dimensions" formControlName="vDimensions">
                                <span class="input-group-text">X</span>
                                </div>
                                <div *ngIf="updatepcbForm.get('vDimensions')?.invalid && updatepcbForm.get('vDimensions')?.touched"
                                        class="improved-error-message ">
                                        <ng-container *ngIf="updatepcbForm.get('vDimensions')?.hasError('pattern')">
                                            Spaces are not allowed at the start or end of the dimension value.
                                          </ng-container>
                                          <ng-container *ngIf="updatepcbForm.get('vDimensions')?.hasError('required')">
                                            This field is required.
                                          </ng-container>
                                    </div>
                                </div>
 
                                <div class="position-relative col-5 p-0">
                                    <div class="d-flex">
                                        <input type="text" class="form-control" id="dimensionsmm"
                                            formControlName="vDimensionsMm">
                                        <span class="input-group-text">mm</span>
                                    </div>
                                    <div *ngIf="updatepcbForm.get('vDimensionsMm')?.invalid && updatepcbForm.get('vDimensionsMm')?.touched"
                                        class="improved-error-message  dimension-error">
                                        <ng-container *ngIf="updatepcbForm.get('vDimensionsMm')?.hasError('pattern')">
                                            Spaces are not allowed at the start or end of the dimension value.
                                          </ng-container>
                                          <ng-container *ngIf="updatepcbForm.get('vDimensionsMm')?.hasError('required')">
                                            This field is required.
                                          </ng-container>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="input-group d-flex align-items-center">
                                <div class="d-flex align-items-center w-100">
                                    <label for="partMounting" class="form-label">Thickness<span
                                            class="text-danger">*</span></label>
                                    <select class="form-select" id="vThikness" formControlName="vThikness">
                                        <option *ngFor="let item of thicknessData let i = index" [value]="item.id">
                                            {{item.Name}}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="input-group d-flex align-items-center">
                                <label for="layers" class="form-label">Layers<span class="text-danger">*</span></label>
                                <input type="text" class="form-control" id="layers" formControlName="vLayers">
                                <div *ngIf="updatepcbForm.get('vLayers')?.invalid && updatepcbForm.get('vLayers')?.touched"
                                    class="improved-error-message">
                                    Invalid input. Please enter even number only.
                                </div>
                            </div>
 
                            <div class="input-group d-flex align-items-center">
                                <div class="d-flex align-items-center w-100">
                                    <label for="partMounting" class="form-label">Part Mounting<span
                                            class="text-danger">*</span></label>
                                    <select class="form-select" id="partMounting" formControlName="vPartmounting">
                                        <option *ngFor="let item of partMountingData let i = index" [value]="item.id">
                                            {{item.Name}}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="input-group d-flex align-items-center">
                                <div class="d-flex align-items-center w-100">
                                    <label for="volumeByTime" class="form-label">Quantity<span
                                        class="text-danger">*</span><span><img style="height: 14px;padding-left:3px" [src]="getImagePath+'info-blue.svg'" alt="" matTooltip="You are allowed to select upto 3 options only at a time"
                                            matTooltipPosition="above"></span></label>
                                            <mat-form-field class="custom-mat-select">
                                                <mat-select multiple required formControlName="quantityControl" (selectionChange)="onSelectionChange()"
                                                (openedChange)="isDropdownOpen = $event">
                                                  <mat-option *ngFor="let quantity of multiplierValues" [value]="quantity" [disabled]="isOptionDisabled(quantity)">
                                                    {{ quantity }}
                                                  </mat-option>
                                                </mat-select>
                                                <mat-icon matSuffix>
                                                  <img [src]="getImagePath + 'dropdown-arrow.svg'" alt="Dropdown">
                                                </mat-icon>
                                              </mat-form-field>
                                              
                                </div>
                                <div *ngIf="updatepcbForm.get('quantityControl')?.touched">
                                    <div *ngIf="updatepcbForm.get('quantityControl')?.invalid;" class="improved-error-message">
                                        Quantity is required, Please select a value.
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="container ">
                            <div class="white-bg row">
                                <div class="input-group d-flex align-items-center col-6">
                                    <label for="volumeByTime" class="form-label">Volume by Time<span
                                            class="text-danger">*</span></label>
                                    <select class="form-select" id="volumeByTime" formControlName="vVolumebyTime">
                                        <option *ngFor="let item of volumeByTimeData let i = index" [value]="item.id">
                                            {{item.Name}}</option>
                                    </select>
 
                                </div>
                                <!-- <div class="input-group d-flex align-items-center col-6">
                                    <label for="volumeInUnits" class="form-label">Volume in Units<span
                                            class="text-danger">*</span></label>
                                    <input type="text" class="form-control" id="volumeInUnits"
                                        formControlName="vVolumebyUnit">
                                    <div *ngIf="updatepcbForm.get('vVolumebyUnit')?.invalid && updatepcbForm.get('vVolumebyUnit')?.touched"
                                        class="improved-error-message">
                                        Invalid value. Please enter a valid number.
                                    </div>
                                </div> -->
                                
                                <div class="input-group d-flex align-items-center col-6">
                                    <label for="totalSMTjoint" class="form-label ">No. of SMT joints<span
                                            class="text-danger ">*</span></label>
                                    <input type="text" class="form-control" id="totalSMTjoint"
                                        formControlName="vTotalSMTJoints" style="width: 60%;">
                                        <div *ngIf="updatepcbForm.get('vTotalSMTJoints')?.touched">
                                            <div *ngIf="updatepcbForm.get('vTotalSMTJoints')?.hasError('required')" class="improved-error-message">
                                                No. of SMT joints is required
                                            </div>
                                            <div *ngIf="updatepcbForm.get('vTotalSMTJoints')?.hasError('pattern')" class="improved-error-message">
                                                Enter a valid positive integer greater than zero
                                            </div>
                                        </div>
                                </div>
 
                                <div class="input-group d-flex align-items-center col-6">
                                    <label for="totalthroughhole" class="form-label">No. of through holes joint<span
                                            class="text-danger">*</span></label>
                                    <input type="text" class="form-control" id="totalthroughhole"
                                        formControlName="vTotalThroughHole" style="width: 60%;">
                                        <div *ngIf="updatepcbForm.get('vTotalThroughHole')?.touched">
                                            <div *ngIf="updatepcbForm.get('vTotalThroughHole')?.hasError('required')" class="improved-error-message">
                                                No. of through holes is required
                                            </div>
                                            <div *ngIf="updatepcbForm.get('vTotalThroughHole')?.hasError('pattern')" class="improved-error-message">
                                                Enter a valid positive integer greater than zero
                                            </div>
                                        </div>
                                </div>
 
                                <!-- <div class="d-flex align-items-center">
                                <label for="weight" class="form-label">Weight :</label>
                                <input type="text" class="form-control" id="weight" formControlName="vWeight">
                            </div>
                            <div *ngIf="updatepcbForm.get('vWeight')?.invalid && updatepcbForm.get('vWeight')?.touched" class="text-danger">
                                Invalid value. Please enter a valid number.
                              </div> -->
                                <div class="d-flex align-items-center col-6">
                                    <label for="Material" class="form-label">Material<span
                                            class="text-danger">*</span></label>
                                    <select class="form-select" id="Material" formControlName="vMaterial">
                                        <option *ngFor="let item of materialData" [value]="item._id">
                                            {{item.vMaterialName}}
                                        </option>
                                    </select>
                                </div>
                                <div class="d-flex align-items-center col-6">
                                    <label for="SurfaceFinishing" class="form-label">Surface Finishing<span
                                            class="text-danger">*</span></label>
                                    <select class="form-select" id="SurfaceFinishing"
                                        formControlName="vSurfaceFinishing">
                                        <option *ngFor="let item of surfaceFinishingData" [value]="item._id">
                                            {{item.vSurfaceFinishingName}}</option>
                                    </select>
                                </div>
                                <div class="d-flex align-items-center col-6">
                                    <label for="CopperThickness" class="form-label">Copper Thickness<span
                                            class="text-danger">*</span></label>
                                    <select class="form-select" id="CopperThickness" formControlName="vCopperThikness">
                                        <option *ngFor="let item of copperThicknessData" [value]="item._id">
                                            {{item.vCopperThicknessName}}</option>
                                    </select>
                                </div>
                                <div class="d-flex align-items-center col-6">
                                    <label for="PCBImpedance" class="form-label">PCB Impedance<span
                                            class="text-danger">*</span></label>
                                    <select class="form-select" id="PCBImpedance" formControlName="vPCBImpendance">
                                        <option *ngFor="let item of pcbImpedanceData" [value]="item._id">
                                            {{item.vPcbImpedanceName}}</option>
                                    </select>
                                </div>
                                <div class="d-flex align-items-center col-6">
                                    <label for="SolderMaskColor" class="form-label">Solder Mask Color<span
                                            class="text-danger">*</span></label>
                                    <select class="form-select" id="SolderMaskColor" formControlName="vSolderMaskColor">
                                        <option *ngFor="let item of solderMaskColorData" [value]="item._id">
                                            {{item.vSolderMaskColorName}}</option>
                                    </select>
                                </div>
                                <div class="d-flex align-items-center col-6">
                                    <label for="SilkScreenColor" class="form-label">Silk Screen Color<span
                                            class="text-danger">*</span></label>
                                    <select class="form-select" id="SilkScreenColor" formControlName="vSilkScreenColor">
                                        <option *ngFor="let item of silkScreenColorData" [value]="item._id">
                                            {{item.vSilkScreenColorName}}</option>
                                    </select>
                                </div>
                                <div class="d-flex align-items-center col-6">
                                    <label for="Coating" class="form-label">Coating<span
                                            class="text-danger">*</span></label>
                                    <select class="form-select" id="Coating" formControlName="vCoating">
                                        <option *ngFor="let item of coatingData" [value]="item.id">{{item.Name}}
                                        </option>
                                    </select>
                                </div>

                                <div class="d-flex align-items-center col-6">
                                    <label for="SilkScreenColor" class="form-label">DesignInPanel<span
                                            class="text-danger">*</span></label>
                                    <select class="form-select" id="DesignInPanel" formControlName="vDesignInPanel">
                                        <option *ngFor="let item of designInPanelData" [value]="item.id">
                                            {{item.Name}}</option>
                                    </select>
                                </div>
                                <div class="d-flex align-items-center col-6">
                                    <label for="Coating" class="form-label">MinTrackSpacing<span
                                            class="text-danger">*</span></label>
                                    <select class="form-select" id="minTrackSpacingData" formControlName="vMinTrackSpacing">
                                        <option *ngFor="let item of minTrackSpacingData" [value]="item.id">{{item.Name}}
                                        </option>
                                    </select>
                                </div>

                                <div class="d-flex align-items-center col-6">
                                    <label for="SilkScreenColor" class="form-label">MinHoleSize<span
                                            class="text-danger">*</span></label>
                                    <select class="form-select" id="MinTrackSpacing" formControlName="vMinHoleSize">
                                        <option *ngFor="let item of minHoleSizeData" [value]="item.id">
                                            {{item.Name}}</option>
                                    </select>
                                </div>
                                <div class="d-flex align-items-center col-6">
                                    <label for="Coating" class="form-label">ViaProcess<span
                                            class="text-danger">*</span></label>
                                    <select class="form-select" id="ViaProcess" formControlName="vViaProcess">
                                        <option *ngFor="let item of viaProcessData" [value]="item.id">{{item.Name}}
                                        </option>
                                    </select>
                                </div>

                                <div class="d-flex align-items-center col-6">
                                    <label for="SilkScreenColor" class="form-label">FinishedCopper<span
                                            class="text-danger">*</span></label>
                                    <select class="form-select" id="SilkScreenColor" formControlName="vFinishedCopper">
                                        <option *ngFor="let item of finishedCopperData" [value]="item.id">
                                            {{item.Name}}</option>
                                    </select>
                                </div>
                                <div class="d-flex align-items-center col-6">
                                    <label for="Coating" class="form-label">FR4Tg<span
                                            class="text-danger">*</span></label>
                                    <select class="form-select" id="FR4Tg" formControlName="vFR4Tg">
                                        <option *ngFor="let item of fR4TgData" [value]="item.id">{{item.Name}}
                                        </option>
                                    </select>
                                </div>
 
                                <div class="d-flex align-items-center col-6">
                                    <label for="Coating" class="form-label">Goldfingers<span
                                            class="text-danger">*</span></label>
                                    <select class="form-select" id="Goldfingers" formControlName="vGoldfingers">
                                        <option *ngFor="let item of goldfingersData" [value]="item.id">{{item.Name}}
                                        </option>
                                    </select>
                                </div>
                                <div class="d-flex align-items-center col-6">
                                    <label for="Coating" class="form-label">FlexibleOption<span
                                            class="text-danger">*</span></label>
                                    <select class="form-select" id="FlexibleOption" formControlName="vFlexibleOption">
                                        <option *ngFor="let item of flexibleOptionData" [value]="item.id">{{item.Name}}
                                        </option>
                                    </select>
                                </div>

                                <div class="d-flex align-items-center col-6">
                                    <label for="Coating" class="form-label">BoardType<span
                                            class="text-danger">*</span></label>
                                    <select class="form-select" id="BoardType" formControlName="vBoardType">
                                        <option *ngFor="let item of boardTypeData" [value]="item.id">{{item.Name}}
                                        </option>
                                    </select>
                                </div>

                                <div class="d-flex align-items-center col-6">
                                    <label for="LogoEtching" class="form-label">Logo Etching</label>
                                    <div class="image-preview" *ngIf="imageSrc">
                                        <img [src]="imageSrc" alt="Preview" />
                                    </div>
                                    <label class="upload-button" for="fileInput">Upload New Logo</label>
                                    <input type="file" id="fileInput" (change)="onFileSelected($event)"
                                        accept="image/png, image/jpeg" hidden formControlName="vLogoEtching" />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <!-- <div class="">
                <div class="mechemical-container mb-3" *ngIf="showMechanicalSpecifications">
                    <div class="sub-header-name">Mechanical Specification Selection</div>
                    <div class="custom-card card-two">
                        <form class="custom-create-project-form" id="updatemechanicalForm"
                            [formGroup]="updatemechanicalForm" (ngSubmit)="UpdateMechanical()">
                        <div class="grey-bg">
                            <div class="input-group d-flex align-items-center">
                                <label for="dimensions2" class="form-label">Dimensions :</label>
                                <div style="display: flex" class="dimension-field">
                                    <input type="text" class="form-control bg-input-grey" id="dimensions2">
                                    <span class="input-group-text">X</span>
                                    <input type="text" class="form-control bg-input-grey">
                                    <span class="input-group-text">mm</span>
                                </div>
                            </div>
                            <div class="input-group d-flex align-items-center">
                                <label for="thickness2" class="form-label">Thickness :</label>
                                <div style="display: flex" class="dimension-field">
                                    <input type="text" class="form-control bg-input-grey" id="thickness2">
                                    <span class="input-group-text" id="basic-addon2">mm</span>
                                </div>
                            </div>
                        </div>
                        <div class="white-bg">
                            <div class="input-group d-flex align-items-center">
                                <label for="category2" class="form-label">Category :</label>
                                <div class="flex-width">
                                    <input type="radio" class="btn-check" name="options-category" id="option-prototype"
                                        autocomplete="off" checked>
                                    <label class="btn" for="option-prototype">Prototype</label>
 
                                    <input type="radio" class="btn-check" name="options-category"
                                        id="option-massManufacturing" autocomplete="off">
                                    <label class="btn" for="option-massManufacturing">Mass
                                        Manufacturing</label>
                                </div>
                            </div>
                            <div class="d-flex align-items-center">
                                <label for="Material" class="form-label">Material Type :</label>
                                <div class="flex-width">
                                    <select class="form-select" id="Material">
                                        <option selected>Plastic</option>
                                        <option value="1">One</option>
                                    </select>
                                </div>
                            </div>
                            <div class="input-group d-flex align-items-center">
                                <label class="form-label">Molding, Machining, Fabrication :</label>
                                <div class="font-14">3D Printed, Vacuum</div>
                            </div>
                            <div class="d-flex align-items-center">
                                <label for="Material2" class="form-label">Material Grade :</label>
                                <div class="flex-width">
                                    <select class="form-select" id="Material2">
                                        <option selected>Fire Resistant</option>
                                        <option value="1">One</option>
                                    </select>
                                </div>
                            </div>
                            <div class="input-group d-flex align-items-center">
                                <label for="surfacefinishing" class="form-label">Surface Finishing :</label>
                                <div class="flex-width">
                                    <input type="radio" class="btn-check" name="options-surfaceFinishing"
                                        id="option-matte" autocomplete="off" checked>
                                    <label class="btn" for="option-matte">Matte</label>
 
                                    <input type="radio" class="btn-check" name="options-surfaceFinishing"
                                        id="option-gloss" autocomplete="off">
                                    <label class="btn" for="option-gloss">Gloss</label>
                                </div>
                            </div>
                            <div class="input-group d-flex align-items-center">
                                <label for="color" class="form-label">Color :</label>
                                <div class="flex-width" style="max-width: 225px !important;">
                                    <input type="text" class="form-control" id="color" placeholder="#000000">
                                    <select class="form-select input-group-text" id="Material">
                                        <option selected>HEX</option>
                                        <option value="1">HSL</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        </form>
                    </div>
                </div>
                <form [formGroup]="testingForm">
                    <div class="sub-header-name mb-3">Testing Requirements</div>
                    <div class="form-floating">
                        <textarea class="form-control grey-textarea" placeholder="Leave a comment here"
                            formControlName="testComment" style="height: 60px"></textarea>
                    </div>
                    <div class="d-flex">
                        <button type="submit" class="btn Testing-btn ms-auto mt-3">Submit</button>
                    </div>
                </form>
            </div> -->
 
            <div class="compliance-container w-25" *ngIf="showAll3">
                <div class="sub-header-name">Compliance</div>
                <div class="custom-card card-three">
                    <form class="custom-create-project-form" name="updatecertificationForm" id="updatecertificationForm"
                        [formGroup]="updatecertificationForm">
                        <div class="check-header">Check which are still required?<span class="text-danger">*</span>
                        </div>
 
                        <div class="form-check" *ngFor="let item of tempComplianceDataArray">
                            <input class="form-check-input" type="checkbox" formControlName="vComplianceCertification"
                                [value]="item._id" (change)="onCheckboxChange($event, item._id)"
                                [checked]="isChecked(item._id)">
                            <label class="form-check-label">{{ item.vCertificationName}}</label>
                        </div>
                        <div *ngIf="updatecertificationForm.get('vComplianceCertification')?.invalid && updatecertificationForm.get('vComplianceCertification')?.touched"
                            class="text-danger">
                            Please Select atleast one.
                        </div>
                        <!-- <div class="check-aditional-header">Add Additional Certifications</div>
                        <div class="form-floating">
                            <textarea class="form-control grey-textarea" placeholder="" id="certifications"
                                style="height: 60px"></textarea>
                        </div>
                        <button class="btn certification-btn"> Add</button> -->
                    </form>
                </div>
                <div class="next-button w-100">
                    <!-- <button class="btn additional-btn"> + Additional Board</button> -->
                    <button class="btn btn-primary improved-add-btn" (click)="UpdatePCB()">Next</button>
                </div>
            </div>
 
        </div>
    </div>
 
    <!-- <div class="chat-bot-position"> <img class="" [src]="getImagePath+'chat-bot.svg'" alt="Logo"></div> -->
</div>
 